import {Dropdown, Tag} from '@/components/atoms'
import {getSegmentsDatafromSegmentsIds} from '@/utils/commons'
import './segmentGroup.scss'

const SegmentGroup = ({
  groupIndex,
  segmentGroup,
  segmentOptions,
  segmentsGroups,
  onSegmentSelection,
  onRemove,
  onDeleteGroup,
  disabled,
}) => {
  // Extract all segment IDs from this group (backend format)
  const allSegmentIds = segmentGroup?.segments || []

  const selectedSegments = getSegmentsDatafromSegmentsIds(allSegmentIds, segmentsGroups)
  const canDelete = groupIndex > 0 && onDeleteGroup !== null // Only groups after the first can be deleted, and only if delete handler is provided

  // Calculate the number of selected segments
  const totalSelections = allSegmentIds.length

  // Determine the selection text based on the number of individual segments
  const getSelectionText = () => {
    if (totalSelections === 0) return null
    if (totalSelections === 1) return 'One selected'
    return 'Multiple selected'
  }

  return (
    <div className="mb-6">
      <div className="mb-4 flex items-center justify-start">
        <div className="products-admin-segment-section-tag-wrapper relative flex items-center gap-2">
          <Dropdown
            isJsonWrap={false}
            childList={segmentOptions}
            isDark
            placeholder="Select Segment(s)"
            label={groupIndex !== null ? `Group ${groupIndex + 1}` : 'Segments'}
            updateValue={items => onSegmentSelection(items, groupIndex)}
            disabled={disabled}
          />

          {totalSelections > 0 && (
            <>
              <div className="selection-overlay pointer-events-none absolute left-0 flex w-full items-center px-3">
                <span className="bg-[#272727] text-sm text-white">{getSelectionText()}</span>
              </div>
              <Tag text={`${totalSelections}`} color="blue" className="absolute right-0 mt-5" />
            </>
          )}
        </div>

        {canDelete && (
          <button
            onClick={() => onDeleteGroup(groupIndex)}
            className="text-blue-1000 ml-4 mt-5 rounded px-3 py-1 text-sm font-bold text-[rgba(102,165,231,1)] hover:text-blue-700"
          >
            Delete Group
          </button>
        )}
      </div>

      <div className="mt-4">
        <SegmentTags
          segments={selectedSegments}
          segmentGroup={segmentGroup}
          onRemove={id => onRemove(id, groupIndex)}
        />
      </div>
    </div>
  )
}

function SegmentTags({segments, onRemove, segmentGroup}) {
  if (segments?.length === 0 && !segmentGroup?.segmentsView?.length) {
    return null
  }

  // Use segmentsView from the backend format directly
  if (segmentGroup?.segmentsView && segmentGroup.segmentsView.length > 0) {
    const allSegments = segmentGroup.segmentsView.map(view => ({
      id: view.segmentId,
      name: view.segmentName,
      groupId: view.segmentGroupId || 'individual-segments',
      isFromFolder: !!view.segmentGroupId,
    }))

    return (
      <div className="flex flex-row flex-wrap items-center gap-2">
        {allSegments.map((segment, index) => (
          <div
            key={`${segment.groupId}-${segment.id}`}
            className="products-admin-segment-group-tag-list-wrapper flex items-center gap-2"
          >
            <Tag
              id={segment.id}
              text={segment.name}
              isRemovable={true}
              onRemove={() => onRemove(segment.id)}
              color={'green'}
            />
            {index < allSegments.length - 1 && <span className="text-sm font-medium text-white">AND</span>}
          </div>
        ))}
      </div>
    )
  }

  return null
}

export default SegmentGroup
